<template>
    <div class="step-box">
        <ul class="steps-title">
            <li
                v-for="(title, index) in stepsArr"
                :key="index"
                :class="[
                    { active: activeId == index },
                    { accomplish: index < activeId },
                    { disabled: index > activeId },
                ]"
                @click="goBack(index)"
            >
                <span v-if="index != 0" class="triangle left-triangle"></span>
                <p>{{ title }}</p>
                <span v-if="index != 3" class="triangle right-triangle"></span>
                <span v-if="index == 3" class="square"></span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        activeId: {
            type: Number,
            default: 0,
        },
        stepsArr: {
            type: Array,
            default: () => {
                return ["1.选择用户", "2.选择系统", "3.申请功能权限", "4.申请数据权限"];
            },
        },
    },
    data() {
        return {
            // stepsArr:
        };
    },
    methods: {
        /**
         * 回退
         */
        goBack(index) {
            if (index >= this.activeId) {
                return;
            }
            this.$emit("goClickStep", index);
        },
    },
};
</script>
<style lang="scss" scoped>
.step-box {
    width: 100%;
    margin-top: 30px;
    padding: 0 20px;
}
.steps-title {
    width: 100%;
    display: flex;
    > li {
        flex: 1;
        position: relative;
        &.disabled {
            cursor: not-allowed;
        }
        p {
            width: calc(100% - 32px);
            height: 32px;
            line-height: 32px;
            background: #f5f7fa;
            text-align: center;
        }
        .triangle {
            display: inline-block;
            position: absolute;
            width: 0;
            height: 0;
            border: 16px solid transparent;
            top: 0;
        }
        .left-triangle {
            border-left-color: #fff;
        }
        .right-triangle {
            border-left-color: #f5f7fa;
            right: 0;
        }
        .square {
            position: absolute;
            width: 32px;
            height: 32px;
            background: #f5f7fa;
            top: 0;
            right: 0;
        }
        &.active {
            p {
                background: $primary;
                color: #fff;
            }
            .right-triangle {
                border-left-color: $primary;
            }
            .square {
                background: $primary;
            }
        }
        &.accomplish {
            cursor: pointer;
            p {
                background: #d9ece6;
                color: $primary;
            }
            .right-triangle {
                border-left-color: #d9ece6;
            }
            .square {
                background: #d9ece6;
            }
        }
    }
}
</style>
